import React from "react";

import { IToc2Column } from "../../../interfaces";

import ColImage from "../../utils/col-image";
import TableOfContents from "../../table-of-contents";

const Toc2Column: React.FC<IToc2Column> = ({ toc, column_2, id }) => {
  return (
    <div className={`cms-col-2 cms-col-2-${id}`}>
      <div className={`py-6 container-r-narrow mx-auto`}>
        <div
          className={`col-group d-flex flex-column flex-md-row height-full container-lg p-responsive`}
        >
          {toc && (
            <div className="col-md-6 height-full col-index-1">
              <TableOfContents {...toc} />
            </div>
          )}
          {column_2 && (
            <div className={`col-md-6 height-full col-index-2`}>
              <div className="col-image-container container-lg padding-r height-full">
                <ColImage {...column_2} />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Toc2Column;
